import * as React from 'react';

function SvgLogout(props) {
  return (
    <svg width={16} height={15} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path d="M3.633 8.383v-2.1c0-1 .817-1.8 1.8-1.8h4.334v-3.7A.74.74 0 009.033.05H.817a.74.74 0 00-.734.733v13.1c0 .4.334.734.734.734h8.25a.74.74 0 00.733-.734v-3.7H5.467c-1.017 0-1.834-.816-1.834-1.8z" />
        <path d="M15.717 6.917L11.9 2.833a.532.532 0 00-.867.417v2.517h-5.6c-.3 0-.533.233-.533.533v2.1c0 .3.233.533.533.533h5.6v2.517c0 .45.517.683.867.417l3.817-4.1a.552.552 0 000-.85z" />
      </g>
    </svg>
  );
}

export default SvgLogout;
